export default __webpack_public_path__ + "static/media/ico-alert-warning.cfcbfed9.svg";